<script lang="ts">
  // Progress ring. `est` = the value is a model estimate (purple), else ink.
  let { value, size = 72, stroke = 7, est = false, label = '' }: { value: number | null; size?: number; stroke?: number; est?: boolean; label?: string } = $props();
  const r = $derived((size - stroke) / 2);
  const C = $derived(2 * Math.PI * r);
  const v = $derived(value === null ? 0 : Math.max(0, Math.min(100, value)));
</script>

<svg width={size} height={size} viewBox="0 0 {size} {size}" role="img" aria-label={label || (value === null ? 'No data' : `${Math.round(v)}%`)} class="ring">
  <circle cx={size / 2} cy={size / 2} {r} fill="none" stroke="var(--card-3)" stroke-width={stroke} />
  <circle cx={size / 2} cy={size / 2} {r} fill="none" stroke={est ? 'var(--est)' : 'var(--ink)'} stroke-width={stroke} stroke-linecap="round"
    stroke-dasharray="{(C * v) / 100} {C}" transform="rotate(-90 {size / 2} {size / 2})" class="arc" />
  <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" class="t" style="font-size:{size * 0.26}px">{value === null ? '—' : `${Math.round(v)}%`}</text>
</svg>

<style>
  .ring { flex: none; display: block; }
  .arc { transition: stroke-dasharray var(--t-med) ease; }
  .t { font-family: var(--display); font-weight: 700; fill: var(--ink); }
</style>
